import {
  isMediaCardType,
  mediaCardTypeToKeys,
} from '@wandb/weave/common/types/media';
import {useCallback} from 'react';

import {useKeyInfoQueryContext} from '../../../MultiRunWorkspace/KeyInfoQueryContext';
import {PanelType} from '../types';

const NUMBER_TYPES = ['line', 'scatter', 'parallel', 'bar', 'scalar'];
const TABLE_FILE_TYPES = ['weave-table', 'weave-plot', 'weave-projector'];
// The following types refer to the new generation of weave panels which include weave-trace, weave-evaluations, etc.
const WEAVE_TYPES = ['weave-trace'];

export const useIsPanelTypeEnabled = () => {
  const {uniqueKeyTypes} = useKeyInfoQueryContext();
  return useCallback(
    (type: PanelType): boolean => {
      // panel types that are always enabled
      if (
        type === 'code' || // TODO: only enable when we have code
        type === 'comparer' ||
        type === 'markdown' ||
        type === 'panel-weave' ||
        type === 'parallel' ||
        type === 'parameter-importance' ||
        type === 'quick-add' ||
        type === 'scatter' ||
        type === 'vega2' ||
        WEAVE_TYPES.includes(type)
      ) {
        return true;
      }

      if (uniqueKeyTypes == null) {
        return false;
      }

      if (NUMBER_TYPES.includes(type)) {
        return uniqueKeyTypes.has('number');
      }

      if (TABLE_FILE_TYPES.includes(type)) {
        return uniqueKeyTypes.has('table-file');
      }

      if (isMediaCardType(type)) {
        const keys = mediaCardTypeToKeys(type);
        for (const key of keys) {
          if (uniqueKeyTypes.has(key)) {
            return true;
          }
        }
      }

      return uniqueKeyTypes.has(type);
    },
    [uniqueKeyTypes]
  );
};
